import { useAuthenticatedQuery } from "@l2r-front/l2r-auth"
import { useExtendWithSubnetworks, useNetworksStateContext } from "@l2r-front/l2r-networks"

import { API_MODULE_SPEEDINGS } from "../../../../common/constants/modules"

import { speedingsQueryKeys } from "./queryKeys"

export function useTrafficStats(params = {}, config = {}) {

    const baseUrl = "traffic/traffics/stats"
    const lightVehicleUrl = `${baseUrl}/average_light_vehicle_count/`
    const heavyVehicleUrl = `${baseUrl}/average_heavy_vehicle_count/`
    const { enabled = true } = config
    const { selectedNetwork } = useNetworksStateContext()

    const parameters = useExtendWithSubnetworks(params, API_MODULE_SPEEDINGS)

    const {
        data: lightVehicleCount,
        isLoading: isLightVehicleCountLoading,
        isError: isLightVehicleCountError,
    } = useAuthenticatedQuery(
        lightVehicleUrl,
        speedingsQueryKeys.lightSpeedLimitsStats(parameters),
        { ...parameters, project: selectedNetwork?.slug },
        {
            ...config,
            enabled: !!selectedNetwork?.slug && enabled,
        },
    )

    const { data: heavyVehicleCount,
        isLoading: isHeavyVehicleCountLoading,
        isError: isHeavyVehicleCountError,
    } = useAuthenticatedQuery(
        heavyVehicleUrl,
        speedingsQueryKeys.heavySpeedLimitsStats(parameters),
        { ...parameters, project: selectedNetwork?.slug },
        {
            ...config,
            enabled: !!selectedNetwork?.slug && enabled,
        },
    )

    return {
        data: {
            ...lightVehicleCount,
            ...heavyVehicleCount,
        },
        isLoading: isLightVehicleCountLoading || isHeavyVehicleCountLoading,
        isError: isLightVehicleCountError || isHeavyVehicleCountError,
    }

}